// Custom GA4 event tracking. Events go directly to GA4 via the gtag.js instance
// loaded by the Google & YouTube sales channel pixel (not via GTM).
// To add a new tracker: write an init function or delegated listener below and
// send events with track(name, params).
(function () {
  var GA_TAG_ID = 'G-JWBM19CBB5'; // GA4 tag configured in the Google & YouTube channel

  // gtag.js processes Arguments objects pushed to window.dataLayer. Must push
  // `arguments` itself — a plain array or object is ignored by gtag.js.
  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  function track(eventName, params) {
    gtag('event', eventName, Object.assign({ send_to: GA_TAG_ID }, params));
  }

  // Exposed for trackers that need data only their own flow has (e.g.
  // assets/cart-promo-code.js), so there is still one gtag path.
  window.trackCustomEvent = track;

  // --- Cart CTA clicks (drawer + cart page) ---------------------------------
  // Capture phase: immune to stopPropagation in theme handlers and AJAX re-renders.
  var CTA_MAP = {
    'CartDrawer-ViewCart': { cta_type: 'view_cart', cta_location: 'drawer' },
    'CartDrawer-Checkout': { cta_type: 'checkout', cta_location: 'drawer' },
    'checkout': { cta_type: 'checkout', cta_location: 'cart_page' }
  };

  document.addEventListener('click', function (event) {
    // Upsell app embeds (lb-upsell) intercept checkout clicks and re-dispatch a
    // synthetic click; count user-initiated clicks only to avoid double-counting.
    if (!event.isTrusted) return;
    if (!event.target || !event.target.closest) return;
    var cta = event.target.closest('#CartDrawer-ViewCart, #CartDrawer-Checkout, #checkout');
    if (cta && CTA_MAP[cta.id]) track('cart_cta_clicked', CTA_MAP[cta.id]);
  }, true);

  // --- Cart drawer opened ---------------------------------------------------
  // Fire once per closed -> open transition of 'active'. DrawerFixed.close()
  // removes only 'active' (keeps 'animate'), so key on 'active' alone.
  function initDrawerTracking() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return; // cart page, notification cart type, or drawer disabled
    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) track('cart_drawer_opened', {});
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // --- Menu tracking: mobile burger drawer + desktop mega menu ---------------
  // Rewritten 2026-09-01. The 27 Aug menu revamp replaced the theme's
  // <details>/<summary> drawer markup with the ab-burger panel model, so the
  // old `summary.menu-drawer__menu-item` hook matched nothing and
  // menu_submenu_opened stopped firing (GA4 mobile: 25.2 events per 1k
  // sessions on 22 Aug, 0.0 from 28 Aug). Confirmed against the live DOM on
  // 2026-09-01: zero elements match summary.menu-drawer__menu-item.
  //
  // Live structure, probed rather than read off the Liquid source:
  //   mobile   #menu-drawer .ab-burger
  //            button.ab-burger-category-row   opens a category panel
  //            button.ab-burger-focus-banner   opens a focus panel
  //            a.ab-burger-product-card, a.ab-burger-other-row
  //            .ab-burger-panel[data-panel-id][data-title], .is-active
  //   desktop  details[data-ab-dmega] > summary.header__menu-item--top
  //            .mm-content with a.mm-card / a.mm-chip / a.mm-cta
  //
  // The drawer open itself still keys on the theme's own burger <details>,
  // which the revamp left in place, so menu_drawer_opened never broke.
  //
  // New params on both events: category, menu_surface, panel_type, link_type.
  // These need registering as event-scoped custom dimensions in GA4 or they
  // are collected but not queryable in reports or the Data API.

  var MEGA_DETAILS = 'details[data-ab-dmega]';
  var DESKTOP_DWELL_MS = 400; // mega panels open on hover: ignore mouse fly-past

  function initMenuDrawerTracking() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;
    details.addEventListener('toggle', function () {
      if (details.open) track('menu_drawer_opened', {});
    });
  }

  // GA4 caps param values at 100 chars. Cards can be image-only, so fall back
  // to aria-label then img alt.
  function linkLabel(el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) text = el.getAttribute('aria-label') || '';
    if (!text) {
      var img = el.querySelector && el.querySelector('img[alt]');
      if (img) text = img.getAttribute('alt') || '';
    }
    return text.slice(0, 100);
  }

  // Cards wrap title, subtitle and price inside one <a>, so textContent would
  // carry the price into the dimension and mint a brand-new value for the same
  // product every time its price changes. Read the title node when there is one.
  var TITLE_SELECTORS = [
    '.mm-card__title', '.mm-chip__zh',
    '.ab-burger-product-card__title', '.ab-burger-other-row__title',
    '.ab-burger-category-row__title', '.ab-burger-focus-banner__title'
  ].join(', ');

  function menuTitle(el) {
    var t = el.querySelector && el.querySelector(TITLE_SELECTORS);
    if (t) {
      var s = (t.textContent || '').replace(/\s+/g, ' ').trim();
      if (s) return s.slice(0, 100);
    }
    return linkLabel(el);
  }

  function textOf(root, selector) {
    var el = root && root.querySelector(selector);
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100) : '';
  }

  // Which surface an element sits in, and which category panel it belongs to.
  // category is '' for the drawer home panel and for top-level nav links.
  function menuContext(el) {
    var mega = el.closest(MEGA_DETAILS);
    if (mega) return { surface: 'megamenu', category: textOf(mega, 'summary') };
    if (el.closest('#menu-drawer')) {
      var panel = el.closest('.ab-burger-panel');
      var id = panel ? (panel.dataset.panelId || '') : '';
      return {
        surface: 'drawer',
        category: (panel && id !== 'home') ? (panel.dataset.title || '').slice(0, 100) : ''
      };
    }
    return null;
  }

  function linkType(el) {
    if (el.closest('.ab-burger-product-card') || el.closest('.mm-card')) return 'product_card';
    if (el.closest('.mm-chip')) return 'chip';
    if (el.closest('.mm-cta')) return 'cta_view_all';
    if (el.closest('.ab-burger-other-row')) return 'other_row';
    return 'plain';
  }

  // Panel opens inside the mobile drawer. Both controls are <button>, not <a>,
  // so they never fall through to the menu_link_clicked branch below.
  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    if (!event.target || !event.target.closest) return;

    var row = event.target.closest('.ab-burger-category-row, .ab-burger-focus-banner');
    if (row) {
      var isFocus = row.classList.contains('ab-burger-focus-banner');
      var name = menuTitle(row);
      track('menu_submenu_opened', {
        category: name,
        menu_surface: 'drawer',
        panel_type: isFocus ? 'focus' : 'category',
        link_text: name, // kept so the pre-27-Aug series stitches on
        menu_level: 2
      });
      return;
    }

    var link = event.target.closest('a[href]');
    if (!link) return;
    var ctx = menuContext(link);
    if (!ctx) return;
    track('menu_link_clicked', {
      category: ctx.category,
      menu_surface: ctx.surface,
      link_type: linkType(link),
      link_text: menuTitle(link),
      link_url: (link.getAttribute('href') || '').slice(0, 100),
      menu_level: ctx.category ? 2 : 1
    });
  }, true);

  // Desktop mega panels. `toggle` does not bubble, and the panels may get
  // data-ab-dmega after DOMContentLoaded, so watch the `open` attribute via
  // MutationObserver instead of binding each <details> at init.
  function armMega(det) {
    if (det.open) {
      det._z21MegaTimer = setTimeout(function () {
        det._z21MegaTimer = null;
        // The theme leaves a panel open after the pointer moves off it, so
        // "still open" is not evidence of intent: one mouse sweep across the
        // nav bar leaves every panel it crossed open, and all of them would
        // clear a plain time-only gate. Require the pointer to still be inside
        // the panel, or keyboard focus to be in it, at the end of the window.
        if (!det.matches(':hover') && !det.contains(document.activeElement)) return;
        var name = textOf(det, 'summary');
        track('menu_submenu_opened', {
          category: name,
          menu_surface: 'megamenu',
          panel_type: 'category',
          link_text: name,
          menu_level: 2
        });
      }, DESKTOP_DWELL_MS);
    } else if (det._z21MegaTimer) {
      clearTimeout(det._z21MegaTimer);
      det._z21MegaTimer = null;
    }
  }

  function initMegaMenuTracking() {
    if (!window.MutationObserver) return;
    var scope = document.querySelector('header') || document.body;
    if (!scope) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.matches && t.matches(MEGA_DETAILS)) armMega(t);
      }
    }).observe(scope, { attributes: true, attributeFilter: ['open'], subtree: true });
  }

  // --- PDP add-to-cart clicks (main button vs sticky bar) --------------------
  // Both main-product sections render the sticky bar as a sibling of the
  // <section id="MainProduct-..."> wrapper, so test sticky-cart first.
  // Quick-add cards, quick view, featured-product, and cart drawer upsell ATCs
  // fall through both checks and are deliberately not counted.
  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('button[name="add"]');
    if (!btn) return;
    if (btn.closest('sticky-cart')) {
      track('atc_clicked', { atc_location: 'sticky_bar' });
    } else if (btn.closest('[id^="MainProduct-"]')) {
      track('atc_clicked', { atc_location: 'pdp_main' });
    }
  }, true);

  // --- Sticky bar variant interactions ---------------------------------------
  // Desktop: the bar has its own <select> dropdowns. isTrusted filters the
  // synthetic change events from the theme's main-picker <-> sticky sync, so
  // only changes the user makes in the bar itself are counted.
  document.addEventListener('change', function (event) {
    if (!event.isTrusted) return;
    var el = event.target;
    if (!el || el.tagName !== 'SELECT' || !el.closest) return;
    if (!el.closest('sticky-cart')) return;
    // Selects are named options[<Option name>], e.g. options[Color]
    var m = (el.name || '').match(/^options\[(.+)\]$/);
    track('sticky_variant_changed', {
      option_name: (m ? m[1] : 'option').slice(0, 100),
      option_value: (el.value || '').slice(0, 100)
    });
  }, true);

  // Mobile: no dropdowns in the bar; the pencil button scrolls to the main
  // picker instead. Class name has the theme's own "stick-cart" typo.
  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    if (!event.target || !event.target.closest) return;
    if (event.target.closest('.stick-cart__variant-select-mobile-button')) {
      track('sticky_variant_edit_clicked', {});
    }
  }, true);

  function initAll() {
    initDrawerTracking();
    initMenuDrawerTracking();
    initMegaMenuTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
